import type * as THREE from "three";

export interface AssemblyPart {
	object: THREE.Object3D;
	baseY: number;
	visible: boolean;
	phase: number;
}

/** Use the built geometry: animation must never approximate dimensions or BOM quantities. */
export function collectFoundationAssembly(
	root: THREE.Object3D,
): AssemblyPart[] {
	const parts: AssemblyPart[] = [];
	root.traverse((object) => {
		const name = object.name;
		const phase = name.startsWith("detail/foundation/plinth-")
			? 0
			: name.startsWith("detail/foundation/shoe-")
				? 1
				: name.startsWith("detail/foundation/beam-")
					? 2
					: name.startsWith("detail/entry/")
						? 3
						: -1;
		if (phase >= 0)
			parts.push({
				object,
				baseY: object.position.y,
				visible: object.visible,
				phase,
			});
	});
	return parts;
}

export function applyFoundationAssembly(
	parts: AssemblyPart[],
	progress: number,
	reducedMotion = false,
): void {
	const clamped = Math.min(1, Math.max(0, progress));
	for (const part of parts) {
		// Entry steps belong to the finished view, outside this three-stage schematic.
		const local =
			part.phase === 3
				? Number(clamped === 1)
				: Math.min(1, Math.max(0, clamped * 3 - part.phase));
		part.object.visible = part.visible && local > 0;
		part.object.position.y =
			part.baseY + (reducedMotion ? 0 : 0.45 * (1 - local) ** 3);
		if (clamped === 1) part.object.position.y = part.baseY;
	}
}
